export default function formatAmount(
  amount,
  settings = { locale: 'en-AU', currency: 'AUD' }
) {
  const { locale, currency } = settings
  if (typeof amount !== 'number') {
    throw new Error('Amount must be a number')
  }
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
